import { Link, Breadcrumbs as MuiBreadcrumbs, Typography } from '@material-ui/core'
import { ComponentProps, ElementType, forwardRef } from 'react'

export function BreadcrumbsComponent({
  links,
  onLinkClick,
  LinkComponent,
}: {
  links: { title: string; link: string }[]
  onLinkClick?: (link: string, option: any) => void
  LinkComponent?: ElementType
}) {
  return (
    <MuiBreadcrumbs aria-label="Breadcrumb" separator={'>'} maxItems={5}>
      {links.map(({ title, link }, index) => {
        const linkProps: ComponentProps<typeof Link> & {
          component?: ElementType
        } = { href: link }
        if (LinkComponent) {
          const LinkC = forwardRef<unknown, ComponentProps<typeof Link>>(function LinkC(p, ref) {
            return (
              <LinkComponent
                {...p}
                ref={ref}
                to={link}
                state={{ hierarchies: links.slice(1, index) }}
              />
            )
          })
          linkProps.component = LinkC
        }
        if (onLinkClick) {
          linkProps.onClick = (e: any) => {
            e.preventDefault()
            if (onLinkClick && link) {
              const options = index === 0 ? {} : { state: { hierarchies: links.slice(1, index) } }
              onLinkClick(link, options)
            }
          }
        }

        // 最後の要素はリンクにしない
        return link && index !== links.length - 1 ? (
          <Link key={link} color="inherit" {...linkProps}>
            {title}
          </Link>
        ) : (
          <Typography key={link} color="textPrimary">
            {title}
          </Typography>
        )
      })}
    </MuiBreadcrumbs>
  )
}
